import { Button, Dialog, DialogContent, DialogTitle, Typography } from "@mui/material";
import { handleClose, handleContinue } from "./api/handlers";
import useUnsavedChangesDialogStore from "./api/store";
import { ModalTransition } from "../transitions";
import StyledDialogActions from "../dialog/dialog-actions";
import { commonButtonProps } from "../buttons/sxprops";

interface IUnsavedChangesDialog {
    onContinue: () => void
}


export const UnsavedChangesDialog: React.FC<IUnsavedChangesDialog> = ({ onContinue }) => {
    const store = useUnsavedChangesDialogStore();
    return <Dialog
        onClose={() => handleClose(store)}
        maxWidth={"mobile"}
        open={store.showUnsavedChangesPrompt}
        slots={{
            transition: ModalTransition,

        }}
        slotProps={{
            paper: {
                sx: {
                    borderRadius: "24px", minWidth: "400px",
                }
            }
        }}
        keepMounted
        aria-describedby="alert-dialog-slide-description"
    >

        <DialogTitle>
            <Typography variant="h5" color={"primary.main"}>
                Unsaved Changes
            </Typography>
        </DialogTitle>

        <DialogContent >
            <Typography variant="body2" color={"text.secondary"}>
                Are you sure you want to go back? Your changes will not be saved.
            </Typography>
        </DialogContent>



        <StyledDialogActions>
            <Button id="cancel-button" onClick={() => handleClose(store)}>Cancel</Button>
            <Button id="continue-button"
                onClick={() => handleContinue(store, onContinue)}
                sx={{
                    ...commonButtonProps,
                    width: "105px",
                }}>Continue</Button>
        </StyledDialogActions>
    </Dialog >;

}